import { render } from "./ProfilePage.vue?vue&type=template&id=6e59c407&scoped=true"
import script from "./ProfilePage.vue?vue&type=script&lang=js"
export * from "./ProfilePage.vue?vue&type=script&lang=js"

import "./ProfilePage.vue?vue&type=style&index=0&id=6e59c407&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e59c407"]])

export default __exports__